import React, { useEffect, useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import { FormControl, FormHelperText, TextField, Typography, Container, Paper, InputLabel, Select, Divider, MenuItem, Button, Grid, CircularProgress } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import SaveIcon from '@material-ui/icons/Save';
import { FeeActions, NotificationActions } from '../../../store';
import { formatFeeNumber, formatPeriod, nextDate } from '../../../utils';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        "& h6": {
            fontSize: '12px'
        }
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const feeSelector = (state) => state.Fees;
const IdentitySelector = (state) => state.Identity;

const FeeManagementEdit = (props) => {

    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const feeActions = bindActionCreators(FeeActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(feeSelector);
    const { token } = useSelector(IdentitySelector);

    const { control, errors, handleSubmit } = useForm();

    const { classes } = props;

    /**
     * 
     * 戻る押下時の処理
     * 
     */
    const onBackClick = () => {
        props.onCancel();
    }

    /**
     * 
     * 登録ボタン押下時の処理
     * 
     */
    const onSubmit = (data, e) => {
        //console.log(`登録　editing.start_date:${editing.start_date}`);
        //console.log(`登録　editing.end_date:${editing.end_date}`);
        editing.start_date = _startDate;
        editing.end_date = editing.end_date.slice(0, 10);
        editing.period = formatPeriod(editing.start_date, editing.end_date) //開始日と終了日から期間を設定
        // 編集した店舗情報を保存
        feeActions.save(token, editing)
            .then(data => {
                // 登録メッセージ表示
                notificationActions.showSuccess('登録しました。');
                // 一覧画面に遷移
                props.onUpdate();
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
    *
    * 入力内容変更時の処理
    *
    */
    const onChange = (e) => {
        const currentState = editing;
        const { name, value } = e[0].target;
        currentState[name] = value;

        if (props.createFlag) {
            // 新規作成の場合のみ加盟店変更可能
            if (name.startsWith('id')) {
                const merchant = editing.selectable_merchants.find(merchant => merchant.id === value);
                currentState['merchant_name'] = merchant.merchant_name;
                currentState['merchant_type'] = merchant.merchant_type;
                feeActions.loadPrevInfo(token, value)
                    .then(
                        (data) => {
                            //console.log(`>>>>>>`);
                            //console.log(`加盟店の切替`);
                            // 翌日取得
                            let nextDay = nextDate(new Date(), 1);
                            if (!data || !data.start_date) {
                                //console.log(`データが取得できない場合は、当日を開始可能日に設定`);
                                // データが取得できない場合は、翌日を開始可能日に設定
                                editing.start_date = new Date(nextDay);
                            } else {
                                //console.log(`データが取得できた場合は、取得した最新レコードの期間(開始)の日付の翌日を開始可能日に設定`);
                                // データが取得できた場合は、取得した最新レコードの期間(開始)の日付の翌日を開始可能日に設定
                                //console.log(`切替　data.start_date:${data.start_date}`);
                                let startDay = nextDate(data.start_date.slice(0, 10), 1);
                                //console.log(`切替　startDay:${startDay}`);
                                // 翌日より過去の場合は翌日を設定
                                editing.start_date = new Date(startDay > nextDay ? startDay : nextDay);
                            }
                            //console.log(`切替　editing.start_date:${editing.start_date}`);
                            let dt = new Date(editing.start_date);
                            let selectDt = dt.getFullYear() + '-' + ("0" + (dt.getMonth() + 1)).slice(-2) + '-' + ("0" + dt.getDate()).slice(-2);
                            //console.log(`切替　setStartDate(selectDt):${selectDt}`);
                            // 期間開始日と下限を設定
                            setStartDate(selectDt);
                            setMinDate(selectDt);
                        }
                    );
            }
        }

        return value;
    }

    /**
     *
     * 開始日選択時の処理
     *
     */
    const onChangeStartDt = (e) => {
        //console.log(`onChangeStartDt`);
        //console.log(`onChangeStartDt e.target.value:${e.target.value}`);
        let value = e.target.value;
        //console.log(`value:${value}`);
        editing.start_date = value;
        let dt = new Date(value);
        let selectDt = dt.getFullYear() + '-' + ("0" + (dt.getMonth() + 1)).slice(-2) + '-' + ("0" + dt.getDate()).slice(-2);
        //console.log(`selectDt:${selectDt}`);
        //console.log(`開始日選択　setStartDate(selectDt):${selectDt}`);
        setStartDate(selectDt);

        return value;
    }

    // 期間開始日
    var defaultDate = new Date().toISOString().slice(0, 10);
    const [_startDate, setStartDate] = useState(defaultDate);
    // 期間開始日の下限の日付
    const [_minDate, setMinDate] = useState();

    /**
     *
     * 初期表示処理
     *
     */
    useEffect(() => {
        //console.log(`******`);
        //console.log(`初期表示　useEffect`);
        // 翌日取得
        let nextDay = nextDate(new Date(), 1);
        let startDate;
        let minDate;
        if (props.createFlag) {
            // 新規作成時は翌日を設定
            editing.start_date = nextDay;
            startDate = nextDay;
            // 期間範囲の下限も翌日
            minDate = nextDay;
        }
        else {
            // 更新時は期間(開始)日付を設定
            startDate = editing.start_date.slice(0, 10);
            // 期間範囲の下限を開始日で設定（とりあえず）
            minDate = startDate;
            if (editing.prev_start_date) {
                // 前連番期間(開始)の日付が指定されている場合は、その翌日を下限に設定
                var prevStartDay = nextDate(editing.prev_start_date.slice(0, 10), 1);
                // 前連番期間(開始)の日付の翌日が翌日より過去の場合は翌日を下限に設定（当日含む過去を設定できない）
                minDate = (prevStartDay > nextDay ? prevStartDay : nextDay);
            }
        }
        // 初期の期間開始日を設定
        //console.log(`　　startDate:${startDate}`);
        setStartDate(startDate);
        // 初期の期間開始日の下限を設定
        //console.log(`　　minDate:${minDate}`);
        setMinDate(minDate);
    }, []);

    if (editing == null) {
        return <div></div>;
    }

    // 終了日は2199年12月31日で固定
    var endDate = new Date('2199-12-31').toISOString().slice(0, 10);

    // 加盟店一覧、期間開始日の活性・非活性の制御
    var merchantNameDisabled = false;
    var creditCardPaymentAgencyIdDisabled = false;
    var startDateDisabled = false;

    //console.log(`------`);
    //console.log(`editing.start_date:${editing.start_date}`);
    if (props.createFlag) {
        //console.log(`新規　props.createFlag:${props.createFlag}`);
        // 新規時は加盟店一覧は活性（選択可）
        merchantNameDisabled = false;
        // 新規時はショップ一覧は活性（選択可）
        creditCardPaymentAgencyIdDisabled = false;
    }
    else {
        //console.log(`更新　props.createFlag:${props.createFlag}`);
        // 編集時は加盟店一覧は非活性（選択不可）
        merchantNameDisabled = true;
        // 編集時はショップ一覧は非活性（選択不可）
        creditCardPaymentAgencyIdDisabled = true;
        let startDate = editing.start_date.slice(0, 10);
        // 翌日取得
        let nextDay = nextDate(new Date(), 1);
        // 開始日が当日か過去日の場合は変更不可
        startDateDisabled = (startDate < nextDay);
    }

    // 手数料チェック値
    var feeMaxLength = 6;
    var feeMin = 0.00;
    var feeMax = 100.00;
    //var feePattern = /^([1-9][0-9]{0,2}|0)(\.[0-9]{1,1})?$/i;
    var feePattern = /^\d{1,3}(\.\d{1,2})?$/i;
    
    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Grid container className={classes.form} spacing={2}>
                    <Grid item xs={12}>
                        <Typography component="h1" variant="inherit">{<FormattedMessage id="FeeManagement.CreateTitle" />}</Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        <InputLabel component="legend"><FormattedMessage id={"FeeManagement.CreateDesc"} /></InputLabel>
                    </Grid>
                </Grid>
                <form className={classes.form} onSubmit={handleSubmit(onSubmit)} noValidate>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <FormControl fullWidth required variant="outlined" error={errors.id && true}>
                                <InputLabel id="merchant-label-payment"><FormattedMessage id={"FeeManagement.MerchantName"} /></InputLabel>
                                <Controller
                                    name="id"
                                    control={control}
                                    onChange={onChange}
                                    defaultValue={editing.id}
                                    disabled={merchantNameDisabled}
                                    rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                                    as={<Select
                                        labelId="merchant-lable-name"
                                        id="fee-merchant"
                                        label={<FormattedMessage id={"FeeManagement.MerchantName"} />}>
                                        {editing.selectable_merchants.map((merchant) => {
                                            return <MenuItem key={merchant.id} value={merchant.id}>{merchant.merchant_name}</MenuItem>
                                        })}
                                    </Select>} />
                                <FormHelperText>{errors.id ? errors.id.message : ""}</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel component="legend"><FormattedMessage id={"Merchant.Period"} /></InputLabel>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField required fullWidth variant="outlined"
                                name="start_date"
                                onChange={onChangeStartDt}
                                rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                                value={_startDate}
                                id="start-date"
                                label={<FormattedMessage id={"Merchant.FromDate"} />}
                                type="date"
                                className={classes.textField}
                                disabled={startDateDisabled}
                                inputProps={{
                                    min: _minDate,
                                    max: endDate,
                                    className: classes.input
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="end_date"
                                control={control}
                                onChange={onChange}
                                defaultValue={endDate}
                                disabled={true}
                                rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                                as={<TextField required fullWidth variant="outlined"
                                    id="end_dt"
                                    label={<FormattedMessage id={"Merchant.ToDate"} />}
                                    type="date"
                                    error={errors.end_date && true}
                                    helperText={errors.end_date ? errors.end_date.message : ""}
                                    className={classes.textField}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel component="legend"><FormattedMessage id={"Merchant.SystemFeeRate"} /></InputLabel>
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="system_fee_okica_card_payment"
                                control={control}
                                onChange={onChange}
                                defaultValue={formatFeeNumber(editing.system_fee_okica_card_payment)}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: {value: feeMaxLength, message: <FormattedMessage id={"Error.FeeMaxLen"} /> },
                                    min: {value: feeMin, message: <FormattedMessage id={"Error.FeeMin"} /> },
                                    max: {value: feeMax, message: <FormattedMessage id={"Error.FeeMax"} /> },
                                    pattern: {value: feePattern, message: <FormattedMessage id={"Error.FeePattern"} /> }
                                }}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.system_fee_okica_card_payment && true}
                                    helperText={errors.system_fee_okica_card_payment ? errors.system_fee_okica_card_payment.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />}0.0</Typography>}
                                    label={<FormattedMessage id={"Merchant.OKICACardPayment"} />} />} />
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="brand_fee_okica_card_payment"
                                control={control}
                                onChange={onChange}
                                defaultValue={formatFeeNumber(editing.brand_fee_okica_card_payment)}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: {value: feeMaxLength, message: <FormattedMessage id={"Error.FeeMaxLen"} /> },
                                    min: {value: feeMin, message: <FormattedMessage id={"Error.FeeMin"} /> },
                                    max: {value: feeMax, message: <FormattedMessage id={"Error.FeeMax"} /> },
                                    pattern: {value: feePattern, message: <FormattedMessage id={"Error.FeePattern"} /> }
                                }}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.brand_fee_okica_card_payment && true}
                                    helperText={errors.brand_fee_okica_card_payment ? errors.brand_fee_okica_card_payment.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />}0.0</Typography>}
                                    label={<FormattedMessage id={"Merchant.BrandCharge"} />} />} />
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="system_fee_qr_payment"
                                control={control}
                                onChange={onChange}
                                defaultValue={formatFeeNumber(editing.system_fee_qr_payment)}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: {value: feeMaxLength, message: <FormattedMessage id={"Error.FeeMaxLen"} /> },
                                    min: {value: feeMin, message: <FormattedMessage id={"Error.FeeMin"} /> },
                                    max: {value: feeMax, message: <FormattedMessage id={"Error.FeeMax"} /> },
                                    pattern: {value: feePattern, message: <FormattedMessage id={"Error.FeePattern"} /> }
                                }}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.system_fee_qr_payment && true}
                                    helperText={errors.system_fee_qr_payment ? errors.system_fee_qr_payment.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />}0.0</Typography>}
                                    label={<FormattedMessage id={"Merchant.QRBalanceSettlement"} />} />} />
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="brand_fee_qr_payment"
                                control={control}
                                onChange={onChange}
                                defaultValue={formatFeeNumber(editing.brand_fee_qr_payment)}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: {value: feeMaxLength, message: <FormattedMessage id={"Error.FeeMaxLen"} /> },
                                    min: {value: feeMin, message: <FormattedMessage id={"Error.FeeMin"} /> },
                                    max: {value: feeMax, message: <FormattedMessage id={"Error.FeeMax"} /> },
                                    pattern: {value: feePattern, message: <FormattedMessage id={"Error.FeePattern"} /> }
                                }}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.brand_fee_qr_payment && true}
                                    helperText={errors.brand_fee_qr_payment ? errors.brand_fee_qr_payment.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />}0.0</Typography>}
                                    label={<FormattedMessage id={"Merchant.BrandCharge"} />} />} />
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel component="legend"><FormattedMessage id={"Merchant.ChargeCommissionRate"} /></InputLabel>
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="merchant_fee_okica_card_charge"
                                control={control}
                                onChange={onChange}
                                defaultValue={formatFeeNumber(editing.merchant_fee_okica_card_charge)}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: {value: feeMaxLength, message: <FormattedMessage id={"Error.FeeMaxLen"} /> },
                                    min: {value: feeMin, message: <FormattedMessage id={"Error.FeeMin"} /> },
                                    max: {value: feeMax, message: <FormattedMessage id={"Error.FeeMax"} /> },
                                    pattern: {value: feePattern, message: <FormattedMessage id={"Error.FeePattern"} /> }
                                }}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.merchant_fee_okica_card_charge && true}
                                    helperText={errors.merchant_fee_okica_card_charge ? errors.merchant_fee_okica_card_charge.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />}0.0</Typography>}
                                    label={<FormattedMessage id={"Merchant.OKICACardCharge"} />} />} />
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="merchant_fee_okica_card_value_exchange"
                                control={control}
                                onChange={onChange}
                                defaultValue={formatFeeNumber(editing.merchant_fee_okica_card_value_exchange)}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: {value: feeMaxLength, message: <FormattedMessage id={"Error.FeeMaxLen"} /> },
                                    min: {value: feeMin, message: <FormattedMessage id={"Error.FeeMin"} /> },
                                    max: {value: feeMax, message: <FormattedMessage id={"Error.FeeMax"} /> },
                                    pattern: {value: feePattern, message: <FormattedMessage id={"Error.FeePattern"} /> }
                                }}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.merchant_fee_okica_card_value_exchange && true}
                                    helperText={errors.merchant_fee_okica_card_value_exchange ? errors.merchant_fee_okica_card_value_exchange.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />}0.0</Typography>}
                                    label={<FormattedMessage id={"Merchant.OKICACardValue"} />} />} />
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel component="legend"><FormattedMessage id={"Merchant.CreditFeeRate"} /></InputLabel>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth required variant="outlined" error={errors.payment_agency_id && true}>
                                <InputLabel id="merchant-label-payment"><FormattedMessage id={"Merchant.Shop"} /></InputLabel>
                                <Controller
                                    name="credit_card_payment_agency_id"
                                    control={control}
                                    onChange={onChange}
                                    defaultValue={editing.credit_card_payment_agency_id}
                                    disabled={creditCardPaymentAgencyIdDisabled}
                                    rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                                    as={<Select
                                        labelId="merchant-label-payment"
                                        id="merchant-payment"
                                        label={<FormattedMessage id={"Merchant.Shop"} />}>
                                        <MenuItem value={100002}><FormattedMessage id={"Merchant.GeneralStore"} /></MenuItem>
                                        <MenuItem value={100003}><FormattedMessage id={"Merchant.Taxi"} /></MenuItem>
                                        <MenuItem value={100004}><FormattedMessage id={"Merchant.Retail"} /></MenuItem>
                                    </Select>} />
                                <FormHelperText>{errors.payment_agency_id ? errors.payment_agency_id.message : ""}</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="system_fee_credit_card_payment"
                                control={control}
                                onChange={onChange}
                                defaultValue={formatFeeNumber(editing.system_fee_credit_card_payment)}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: { value: feeMaxLength, message: <FormattedMessage id={"Error.FeeMaxLen"} /> },
                                    min: { value: feeMin, message: <FormattedMessage id={"Error.FeeMin"} /> },
                                    max: { value: feeMax, message: <FormattedMessage id={"Error.FeeMax"} /> },
                                    pattern: { value: feePattern, message: <FormattedMessage id={"Error.FeePattern"} /> }
                                }}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.system_fee_credit_card_payment && true}
                                    helperText={errors.system_fee_credit_card_payment ? errors.system_fee_credit_card_payment.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />}0.0</Typography>}
                                    label={<FormattedMessage id={"Merchant.SystemFee"} />} />} />
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="brand_fee_credit_card_payment"
                                control={control}
                                onChange={onChange}
                                defaultValue={formatFeeNumber(editing.brand_fee_credit_card_payment)}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: { value: feeMaxLength, message: <FormattedMessage id={"Error.FeeMaxLen"} /> },
                                    min: { value: feeMin, message: <FormattedMessage id={"Error.FeeMin"} /> },
                                    max: { value: feeMax, message: <FormattedMessage id={"Error.FeeMax"} /> },
                                    pattern: { value: feePattern, message: <FormattedMessage id={"Error.FeePattern"} /> }
                                }}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.brand_fee_credit_card_payment && true}
                                    helperText={errors.brand_fee_credit_card_payment ? errors.brand_fee_credit_card_payment.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />}0.0</Typography>}
                                    label={<FormattedMessage id={"Merchant.BrandCharge"} />} />} />
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel component="legend"><FormattedMessage id={"Merchant.BankChargeRate"} /></InputLabel>
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="system_fee_bank_payment"
                                control={control}
                                onChange={onChange}
                                defaultValue={formatFeeNumber(editing.system_fee_bank_payment)}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: { value: feeMaxLength, message: <FormattedMessage id={"Error.FeeMaxLen"} /> },
                                    min: { value: feeMin, message: <FormattedMessage id={"Error.FeeMin"} /> },
                                    max: { value: feeMax, message: <FormattedMessage id={"Error.FeeMax"} /> },
                                    pattern: { value: feePattern, message: <FormattedMessage id={"Error.FeePattern"} /> }
                                }}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.system_fee_bank_payment && true}
                                    helperText={errors.system_fee_bank_payment ? errors.system_fee_bank_payment.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />}0.0</Typography>}
                                    label={<FormattedMessage id={"Merchant.SystemFee"} />} />} />
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="brand_fee_bank_payment"
                                control={control}
                                onChange={onChange}
                                defaultValue={formatFeeNumber(editing.brand_fee_bank_payment)}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: { value: feeMaxLength, message: <FormattedMessage id={"Error.FeeMaxLen"} /> },
                                    min: { value: feeMin, message: <FormattedMessage id={"Error.FeeMin"} /> },
                                    max: { value: feeMax, message: <FormattedMessage id={"Error.FeeMax"} /> },
                                    pattern: { value: feePattern, message: <FormattedMessage id={"Error.FeePattern"} /> }
                                }}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.brand_fee_bank_payment && true}
                                    helperText={errors.brand_fee_bank_payment ? errors.brand_fee_bank_payment.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />}0.0</Typography>}
                                    label={<FormattedMessage id={"Merchant.BrandCharge"} />} />} />
                        </Grid>
                        <Grid item xs={6}>
                            <Button fullWidth variant="contained" size="medium"
                                startIcon={<ArrowBackIosIcon />}
                                onClick={onBackClick}><FormattedMessage id="Button.Back" /></Button>
                        </Grid>
                        <Grid item xs={6}>
                            <Button fullWidth variant="contained" size="medium" color="primary"
                                onClick={handleSubmit(onSubmit)}
                                endIcon={<SaveIcon />}>
                                <FormattedMessage id="Button.Register" />
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(FeeManagementEdit);
